export default __webpack_public_path__ + "images/a4b5de1744f73dc58ad0addd439a9d64.png";